import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('tutorToken');
  
  if (!token) {
    return <Navigate to="/tutor/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
